import React from "react";
import { FaArrowRight, FaStar } from "react-icons/fa";

type HeroSectionProps = {
  name: string;
  backgroundImage: string;
  archImage: string;
  description: string;
  shortDescription?: string;
  backgroundVideo?: string;
};

const HeroSection: React.FC<HeroSectionProps> = ({
  name,
  backgroundImage,
  backgroundVideo,
}) => {
  return (
    <section className="relative h-screen min-h-[600px] md:min-h-[600px] w-full bg-brand-dark overflow-hidden pt-20">
      
      {/* Background */}
      <div className="absolute inset-0 z-0">
        {backgroundVideo ? (
          <video
            src={backgroundVideo}
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover opacity-60"
          />
        ) : (
          <img
            className="w-full h-full object-cover opacity-60"
            src={backgroundImage}
            alt={`${name} landscape`}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/80 via-transparent to-brand-dark/90" />
      </div>

      {/* Arch Image — hidden when video is available */}
      {/* {!backgroundVideo && (
      <div className="absolute inset-x-0 bottom-0 top-32 z-10 flex justify-center items-end opacity-90">
        <div className="w-full max-w-3xl h-[80%] arch-mask overflow-hidden relative border-t border-white/20">
          <img
            className="w-full h-full object-cover object-center"
            src={archImage}
            alt={`${name} highlight`}
          />
          <div className="absolute inset-0 bg-brand-dark/20 mix-blend-overlay" />
        </div>
      </div>
      )} */}

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 pt-4">

        {/* Top */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end w-full animate-slide-up">
          <div className="max-w-md">
            <h2 className="text-white/80 font-heading text-xl md:text-xl uppercase tracking-[0.2em] leading-tight mb-2">
              TRAVEL <br /> EXPLORE <br /> TRANSFORM
            </h2>
          </div>

          {/* Reviews */}
          <div className="mt-8 md:mt-0 text-right hidden md:block">
            <div className="flex items-center gap-4 text-white/80">

              {/* Avatars */}
              <div className="flex -space-x-3">
                <img className="w-10 h-10 rounded-full border-2 border-brand-dark" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/1a17294413-2fc9fe21438cfd7c62b9.png" />
                <img className="w-10 h-10 rounded-full border-2 border-brand-dark" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/9a945b3c05-37667f08571da5203e67.png" />
                <img className="w-10 h-10 rounded-full border-2 border-brand-dark" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/2e0ff08cd6-d6866f7cbc0c6c08f81a.png" />
              </div>

              {/* Rating */}
              <div className="text-left">
                <div className="flex text-brand-accent text-sm">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
                <span className="text-xs font-medium">
                  4.9/5 from 2,000+ travelers
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Huge Text */}
        <div className="w-full flex justify-center items-center z-30 pointer-events-none">
          <h1 className="font-heading text-[12vw] sm:text-[10vw] md:text-[14vw] lg:text-[150px] font-bold text-white tracking-tighter leading-none hero-text-overlay text-center">
            {name.toUpperCase()}
          </h1>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-end w-full animate-slide-up">
          {/* <div className="max-w-xl text-left text-white/85">
            <p className="text-sm leading-7 sm:text-base">
              {shortDescription || description}
            </p>
          </div> */}

          {/* Circular Button — right aligned */}
          <div className="ml-auto relative w-32 h-32 md:w-40 md:h-40 flex items-center justify-center cursor-pointer group">

            {/* Rotating Text */}
            <div className="absolute inset-0 animate-spin-slow text-white/80">
              <svg viewBox="0 0 100 100" className="w-full h-full">
                <path
                  id="circlePath"
                  d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
                  fill="transparent"
                />
                <text className="text-[10px] uppercase tracking-widest font-medium">
                  <textPath href="#circlePath">
                    * START YOUR JOURNEY * START YOUR JOURNEY
                  </textPath>
                </text>
              </svg>
            </div>

            {/* Center Button */}
            <a
              href="#overview"
              className="w-16 h-16 md:w-20 md:h-20 rounded-full border border-white/30 backdrop-blur-md flex items-center justify-center text-white group-hover:bg-white group-hover:text-brand-dark transition-all duration-500 z-10"
            >
              <FaArrowRight className="-rotate-45 group-hover:rotate-0 transition-transform duration-500 text-xl md:text-2xl" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

